import * as React from "react";
import { BaseBlock, broadcastBlockLoad } from "sb-resp-block-lib";
import { internalMessageBus, InternalMessageBusChannels } from "sb-internal-msg-bus";
import { BaseDict } from "./dict";
import { config } from "./config";
import { AggregatesViewPresenterBlock } from "./ui/AggregatesViewPresenterBlock";
import { AggregatesViewPresenterBlockState } from "./state";
let _;
let AggregatesDataMock;
if (process.env.NODE_ENV === "development") {
    _ = require("../../mocks");
    AggregatesDataMock = _.AggregatesDataMock;
}
export class AggregatesViewPresenterBlockRoot extends BaseBlock {
    // constructor sets defaults
    constructor(domId, options = {
        dict: BaseDict,
        cms: {},
        navHandler: {},
        dataProvider: {},
        betSlipUtil: {},
        oddsUtil: {},
        facade: {},
        gameStatus: {},
        timeControl: {},
        panelId: "",
        storageUtils: {},
        userInfo: {}
    }) {
        super(domId, options);
        if (process.env.NODE_ENV === "development") {
            // setup data mocks for debug build
            this.dataProvider = new AggregatesViewPresenterBlockState(internalMessageBus);
            //export data store to window for debug purposes
            window["AggregatesViewPresenterBlockState"] = this.dataProvider;
            window["AggregatesIncidentsDataMock"] = new AggregatesDataMock(internalMessageBus);
            window["AggregatesIncidentsDataMock"].activate();
            // TODO: Reviewer - Maybe use NavHandlerMock and add to it goBack?
            this.options.navHandler.goBack = () => { };
        }
        if (process.env.NODE_ENV === "production" && typeof options.dataProvider !== "undefined") {
            // use internalMessageBus passed during the construction from the
            // mobile application
            this.dataProvider = new AggregatesViewPresenterBlockState(options.dataProvider);
            // use Application.goBack() from mobile solution
            this.options.navHandler.goBack = options.navHandler.goBack;
        }
        // if no provided dictionary is not full fill in the missing keys with the base one
        this.options.dict = Object.assign(Object.assign({}, BaseDict), (options.dict || {}));
        // merge default and CMS options
        this.options.cms = Object.assign(Object.assign({}, config), (options.cms || {}));
    }
    beforeActivate() {
        this.dataProvider.provider.emit(InternalMessageBusChannels.aggregatedEvents.retrieval.activate, {});
        return this;
    }
    activate() {
        this.dataProvider.activate();
        return super.activate(React.createElement(AggregatesViewPresenterBlock, { dataProvider: this.dataProvider, dict: this.options.dict, options: this.options }));
    }
    beforeDeactivate() {
        this.dataProvider.provider.emit(InternalMessageBusChannels.aggregatedEvents.retrieval.deactivate, {});
        return this;
    }
    deactivate() {
        this.dataProvider.deactivate();
        if (process.env.NODE_ENV === "development") {
            window["AggregatesIncidentsDataMock"].deactivate();
        }
        return super.deactivate();
    }
}
window["AggregatesViewPresenterBlock"] = AggregatesViewPresenterBlockRoot;
broadcastBlockLoad("AggregatesViewPresenterBlock");
//# sourceMappingURL=index.js.map